import { Component, ElementRef, Renderer2, ViewChild } from "@angular/core";
import { AuthenticationService } from "../../../_services/authentication.service";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"],
})
export class HeaderComponent {
  isUserMenuOpen;
  user;
  // notifications;

  notificationsNum = 0;
  isLoadingGeneral;
  @ViewChild("headerRef", { static: true }) headerRef: ElementRef;
  constructor(
    private authenticationService: AuthenticationService,
    private renderer: Renderer2
  ) {
    this.isLoadingGeneral = false;
  }

  fixedHeader() {
    const scrolled =
      window.pageYOffset !== undefined
        ? window.pageYOffset
        : (
            document.documentElement ||
            document.body.parentElement ||
            document.body
          ).scrollTop;

    if (scrolled >= 30) {
      this.renderer.addClass(
        this.headerRef.nativeElement,
        "small-fixed-header-admin"
      );
    } else {
      this.renderer.removeClass(
        this.headerRef.nativeElement,
        "small-fixed-header-admin"
      );
    }
  }
}
